<script lang="ts">
  import type { ActionReturn } from "svelte/action"
  import { getAuth, signOut, type Unsubscribe, type User } from "firebase/auth"

  import { loggedIn } from "."
  import { signInDefault, type SignedInAttributes } from "./actions"
  import { setAnalyticsUser, watchLoginIdentifier } from "@/utils/firebase"

  export let action: (node: HTMLElement, any?: any) => ActionReturn<any, SignedInAttributes> = signInDefault
  export let param: any = null
  export let allowMultipleLogin = true

  let unsub: Unsubscribe = null
  let showLogin = false
  let showApp = false
  let isDoubleLogin = false

  async function onSignIn(e: CustomEvent<User>) {
    unsub?.()
    unsub = null
    isDoubleLogin = false

    // Analytics にユーザー情報を紐付ける
    setAnalyticsUser(e.detail)

    if (!allowMultipleLogin && !e.detail.isAnonymous) {
      // 多重ログインを監視
      unsub = await watchLoginIdentifier(() => {
        isDoubleLogin = true
        signOut(getAuth())
      })
    }

    $loggedIn = true
    showLogin = false
    showApp = true
  }

  function onSignedOut() {
    unsub?.()
    unsub = null

    $loggedIn = false
    showLogin = true
    showApp = false
  }
</script>

<div id="auth-container" on:signin={onSignIn} on:signedout={onSignedOut} use:action={param}>
  {#if isDoubleLogin}
    <p>ログイン上限数に達したためログアウトしました。</p>
  {:else}
    {#if showLogin}
      <slot name="login" />
    {/if}
    {#if showApp}
      <slot name="app" />
    {/if}
  {/if}
</div>

<style>
  p {
    color: red;
  }
</style>
